import { Translation } from '@/components/foundation/Translation'
import { ErrorComponent } from '@/components/ui/Error'
import { Loading } from '@/components/ui/Loading'
import { Schedule } from '@/components/ui/Schedule'
import { useDataFullLine } from '@/hooks/data/useDataFullLine'
import { useMobile } from '@/hooks/useMobile'
import { useModule } from '@/hooks/useModule'
import { useTranslator } from '@/hooks/useTranslator'
import { useSelector } from '@/stores/hooks'
import type { LoadingState } from '@/stores/loading'
import { getNextTrip } from '@/stores/nextTrips'
import { getStop } from '@/stores/stops'
import type { Connection } from '@common/types/Area'
import { Link, useSearch } from 'wouter'
import styles from './AreaConnectionNextTrips.scss'

export function AreaConnectionNextTrips({
	line,
	stop,
	direction,
	statusNextTrips,
	errorNextTrips,
}: Connection & {
	statusNextTrips: LoadingState['status']
	errorNextTrips?: string
}) {
	const translator = useTranslator()
	const currentParams = new URLSearchParams(useSearch())
	const nextTrip = useSelector(state =>
		getNextTrip(state, line, direction, stop),
	)

	const stopData = useSelector(state => getStop(state, stop))
	const mobile = useMobile()
	const maxTrips = mobile ? 1 : 2
	const {
		status: statusLine,
		line: dataLine,
		error: errorLine,
	} = useDataFullLine(line)
	const module = useModule()

	// if one status is failed
	if (statusLine === 'failed') return <ErrorComponent errorId={errorLine} />

	// if one status or dataline is udefined is not loaded
	if (statusLine !== 'loaded' || !dataLine) return <Loading />

	const route = dataLine.routes.find(route => route.direction === direction)

	return (
		<div className={styles.areaLinkContainer}>
			<Link
				href={`${module.path}/${line}/${direction}/${stop}?${currentParams.toString()}`}
			>
				<div className={styles.connection}>
					{/*voice over lit deux fois la ligne (une fois par direction)*/}
					<div
						className={styles.directionContainer}
						aria-label={translator.translate(
							'lines:area-connections:aria:area',
							{
								line: dataLine.code,
								direction: route?.name,
								stop: stopData?.name,
							},
						)}
					>
						<div className={styles.routeContainer}>
							<div className={styles.nameRoute} key={route?.name}>
								<span className={styles.suggestionBoundary}>
									{route?.boundaries.join(', ')}
								</span>
								<span className={styles.directionText}>
									{route?.name}
								</span>
							</div>
						</div>
					</div>
					<div className={styles.nextTripsContainer}>
						{statusNextTrips !== 'loaded' ? (
							<ErrorComponent errorId={errorNextTrips} />
						) : nextTrip?.schedules[0] ? (
							nextTrip.schedules
								.slice(0, maxTrips)
								.map(schedule => (
									<Schedule
										schedule={schedule}
										key={schedule.dateTime}
									/>
								))
						) : (
							<div className={styles.nextTripsContainer}>
								<Translation id="no-next-schedules" />
							</div>
						)}
					</div>
				</div>
			</Link>
		</div>
	)
}
